import React from 'react';

/**
 * ErrorBoundary — catches render errors in any child subtree and shows a
 * friendly fallback instead of a blank screen. Wrap each top-level tab.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Logging error details is intentional here — this is an operational boundary
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>Something went wrong</div>
          <div style={{ fontSize: 12, color: 'var(--mut)', marginBottom: 20, lineHeight: 1.6 }}>
            This section ran into an unexpected error.
            <br />
            Your data is safe — try refreshing or tapping below.
          </div>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{
              padding: '10px 20px',
              borderRadius: 10,
              background: 'var(--ylw)',
              color: '#000',
              fontWeight: 700,
              fontSize: 13,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
